"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProvidersRequestStatus = exports.getProviderNames = void 0;

var getProviderNames = function getProviderNames(state) {
  return state.providers.names;
};

exports.getProviderNames = getProviderNames;

var getProvidersRequestStatus = function getProvidersRequestStatus(state) {
  return state.providers.requestStatus;
};

exports.getProvidersRequestStatus = getProvidersRequestStatus;